import InquiryApi from '@apis/inquiry/InquiryApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetInquiriesParams } from '@models/inquiry';

const inquiryQueries = createQueryKeys('inquiry', {
    types: () => ({
        queryKey: ['types'],
        queryFn: () => InquiryApi.getInquiryTypes(),
    }),
    list: (params: Omit<GetInquiriesParams, 'page'>) => ({
        queryKey: ['list', params],
    }),
    detail: (inquiryId: string) => ({
        queryKey: ['detail', inquiryId],
        queryFn: () => InquiryApi.getInquiry(inquiryId),
    }),
});

export default inquiryQueries;
